// AppInsights.ts
// for setup and configuration see https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-react-plugin

import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { history } from 'app/store';

const reactPlugin = new ReactPlugin();
let appInsights = new ApplicationInsights({
    config: {
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: history }
        }
    }
})


const RegisterApplicationInsights = (connectionString: string) => {
    appInsights = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history: history }
            },
        },
    })
    appInsights.loadAppInsights();

    // prevent certain telemetry from being sent by returning false
    appInsights.addTelemetryInitializer((envelope) => {
        // envelope.tags['ai.cloud.role'] = 'Group Library Portal Client'; // App name

        envelope.data = envelope.data || {};
        envelope.data.baseData = envelope.data.baseData || {};
        envelope.data.baseData.properties = envelope.data.baseData.properties || {};
        envelope.data.baseData.properties.appVersion = process.env.REACT_APP_VERSION; // App version

        // BCBSSC regular users have an extension that causes an exception:
        // before the code manages to finish the service cycle, another one is queued or ignored.
        // ResizeObserver loop completed with undelivered notifications.
        // ResizeObserver loop limit exceeded
        if (envelope?.data?.message?.includes('ResizeObserver loop'))
            return false;

        return true;
    });

    console.debug("[appl] AppInsight.RegisterApplicationInsights")
}


export { appInsights, reactPlugin, RegisterApplicationInsights };
